// Contrôles précédent / suivant du rail des réalisations.
// Le rail est un conteneur à défilement natif (comme dans la maquette) : on ne fait que le
// faire défiler d'une carte. Le défilement au doigt et à la molette fonctionne sans JavaScript.
document.addEventListener('DOMContentLoaded', () => {
  for (const nav of document.querySelectorAll('[data-rail-nav]')) {
    const rail = document.querySelector(nav.dataset.railNav)
    if (!rail) {
      continue
    }

    nav.addEventListener('click', () => {
      const card = rail.firstElementChild
      const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0) : rail.clientWidth
      rail.scrollBy({
        left: nav.dataset.railDirection === 'prev' ? -step : step
      })
    })
  }
})
